module.exports = "/packs/013-7b788acc121309ced5b5474edb0cbe85.jpg";